import { TextFieldProps } from '@mui/material/TextField';
import { Traveller as WidgetTraveller } from '@websky/every-travel/src/types';
import * as React from 'react';
import Input from '../../../../../Input';
import PhoneInput from '../../../../../PhoneInput';
import Autocomplete from '../../../../../Autocomplete';
import { ThemeProvider, useTheme } from '../../../../../theme';
import { concatPassengerNames } from '../../../../../utils';

interface Props {
	label: string;
	name: string;
	TextFieldProps?: TextFieldProps;
	type: string;
	error?: boolean;
	helperText?: string;
	onAutocompleteSelect?: (values: any) => void;
	withAutocomplete?: boolean;
	travellers?: WidgetTraveller[];
}

const EveryTravelInput: React.FC<Props> = props => {
	const theme = useTheme('Checkout').EveryTravelInput;

	if (props.type === 'number') {
		const inputProps = props.TextFieldProps.InputProps;

		return (
			<PhoneInput
				value={inputProps.value as string}
				textFieldsProps={{
					label: props.label,
					name: inputProps.name,
					onChange: inputProps.onChange,
					onBlur: inputProps.onBlur,
					error: props.TextFieldProps.error,
					helperText: props.TextFieldProps.helperText
				}}
			/>
		);
	}

	if (props.withAutocomplete && props.travellers?.length) {
		const inputProps = props.TextFieldProps.InputProps;

		const themeAutocomplete = {
			Autocomplete: {
				Autocomplete: {
					option: theme.autocomplete__option
				}
			}
		};

		return (
			<ThemeProvider value={themeAutocomplete}>
				<Autocomplete
					name={inputProps.name}
					label={props.label}
					inputValue={inputProps.value as string}
					error={props.TextFieldProps.helperText as string}
					onInputChange={inputProps.onChange}
					onSelect={props.onAutocompleteSelect}
					options={props.travellers.map(traveller => ({
						value: traveller.id,
						label: concatPassengerNames({ lastName: traveller.lastname, firstName: traveller.firstname })
					}))}
				/>
			</ThemeProvider>
		);
	}

	return <Input {...props} />;
};

export default EveryTravelInput;
